<mat-card style="width: max-content; max-width: 100%;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
                <mat-card-title class="">
                    Clinical Observations for
                    <a (click)="patientOpenAndClose.openPatientDetailsStrip()"
                        style="text-decoration: none; cursor: pointer; color: var(--mat-sys-primary);"
                        routerLinkActive="router-link-active">
                        {{patientName | async}}
                    </a>
                </mat-card-title>
                <mat-card-subtitle>
                    Find, search and add lab results, vital signs and other Clinical Observations for this patient
                </mat-card-subtitle>
            </div>
            <div class="right gap-10 g-just-flex">
                <!-- @if (canExportObservation) {
                <a mat-flat-button extended class="secondary-button small-button">
                    <mat-icon>file_download</mat-icon> Export
                </a>
                } -->
                @if (canAddObservation) {
                <a mat-flat-button class="" (click)="openAddObservationDialog()">
                    <mat-icon>add</mat-icon>
                    Add Observations
                </a>
                }
            </div>
        </div>
    </mat-card-header>

    <mat-card-content class="my-12">
        <mat-divider></mat-divider>
       
        <div class="my-15">
            <app-custom-tabs [tabs]="categoryTabs" [control]="categoryFiltering" />
        </div>
                <app-table-header [patientsTableFilterArray]="patientObservationTableFilterArray"
                        [patientsFiltersFormControlObject]="patientObservationFiltersFormControlObject"
                        
                        (filterChanged)="onHeaderFilterChanged($event)"
                        (searchCriteriaChanged)="onHeaderSearchCriteriaChanged($event)"
                [searchableFields]="observationSearchFieldOptions"
            [selectedSearchField]="selectedSearchField" searchBoxTitle="Search Observations"
            >
        </app-table-header>

                <!-- <div style="display:flex; justify-content:flex-end; margin-top:8px;">
                    <button mat-stroked-button color="primary" (click)="openFiltersDialog()">
                        <mat-icon>filter_alt</mat-icon>
                        Advanced Filters
                    </button>
                </div> -->
        <div class="table-or-empty">
              @if (loading$ | async) {
        <div class="loading-shade g-just-flex flex-center">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }
      <!-- {{tableDataLevel2 | async | json}} -->
            @if((tableDataLevel2 | async)?.length > 0) {
            <!-- existing table -->
            <table mat-table matSort [dataSource]="tableDataSource" class="mat-elevation-z8 demo-table">

                <!--name - coding.code.display-->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="name" sortActionDescription="Sort by Name">
                        Name
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="restrict-length" style="max-width: 100%;">
                            <!-- {{element.codeDisplay}} -->
                            {{ (element.codeDisplay || (element.rawResource?.code | codeableConcept2)) | na | titlecase }}
                        </span>
                    </td>
                </ng-container>

                <!--dateTaken - effectiveDateTime -->
                <ng-container matColumnDef="dateTaken">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="dateTaken"
                        sortActionDescription="Sort by Date Taken">
                        Date Taken
                    </th>
                    <td mat-cell *matCellDef="let element" style="padding-top: 4px; padding-bottom: 4px;">
                        <span class="restrict-length">{{ element.effectiveDateIso | date: 'mediumDate' | na }}</span>
                        <br>
                        <span class="restrict-length subtitle-text-color-2 small-subtitle">
                            {{ element.effectiveDateIso | date: 'shortTime' | na }}
                        </span>
                    </td>
                </ng-container>

                <!--category - category.coding.display -->
                <ng-container matColumnDef="category">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="category"
                        sortActionDescription="Sort by Category">
                        Category
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="restrict-length">
                            <!-- {{element.categoryDisplay}} -->
                            {{ (element.categoryDisplay || (element.rawResource?.category | joinedcodeableconcept)) | titlecase | na }}
                        </span>
                    </td>
                </ng-container>

                <!--result - valueQuantity.value -->
                <ng-container matColumnDef="result">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="result"
                        sortActionDescription="Sort by Result">
                        Result
                    </th>
                    <td mat-cell *matCellDef="let element" style="padding-top: 10px; padding-bottom: 10px;
                    white-space: normal; line-height: 1.2;
                    ">
                        <!-- <span [appTruncateWords]="10" maxWidth="360px" [wrap]="true" tooltipPosition="above"
                            [showIcon]="true"> -->
                            <app-observation-value-display [observation]="element.rawResource"></app-observation-value-display>
                    </td>
                </ng-container>

                <!--status - status -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="status"
                        sortActionDescription="Sort by Status">
                        Status
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <!-- @if(element.rawResource?.status) { -->
                            
                            <div [appChips]="element.rawResource?.status" fontSize="14px"></div>
                        <!-- }@else {
                            <span class="subtitle-text-color-2">N / A</span>
                        } -->
                    </td>
                </ng-container>

                <!-- practitioner - performer.reference -->
                <ng-container matColumnDef="practitioner">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="practitioner"
                        sortActionDescription="Sort by Practitioner">
                        Practitioner
                    </th>
                    <td mat-cell *matCellDef="let element">
                        @if(element.rawResource?.performer?.length > 0) {
                        <div class="top">
                            
                            <!-- <span [appReferenceDisplay]="element.performer?.[0]?.reference"></span> -->
                            <span [appReferenceDisplay]="element.rawResource?.performer?.[0]?.reference"
                                InstantfetchAndRepace="true"></span>
                        </div>
                        @if(element.performerCount && element.performerCount > 1){
                        <div class="subtitle-text-color-2 small-subtitle">
                            + {{element.performerCount - 1}} more
                        </div>
                        }
                    }@else {
                            <span class="subtitle-text-color-2">N / A</span>
                        }
                    </td>
                </ng-container>

                <!-- action column -->
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>
                        Actions
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="g-just-flex gap-8 py-8" style="align-items: center;">
                            <button mat-button color="primary" (click)="showDetails(element)">
                                View
                            </button>
                            <button mat-icon-button [matMenuTriggerFor]="actionMenu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #actionMenu="matMenu">
                                @if (canManageManualReferenceRanges$ | async) {
                                    <button mat-menu-item (click)="openReferenceRangeDialog(element)"
                                        [disabled]="!element?.id">
                                        <mat-icon color="accent">analytics</mat-icon>
                                        <span>Manage Reference Range</span>
                                    </button>
                                }
                            </mat-menu>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="patientObservationDisplayedColumns" matHeaderRowDefSticky="true">
                </tr>
                <tr mat-row *matRowDef="let row; columns:patientObservationDisplayedColumns">
                </tr>
                </table>
<div class="gap my-12"></div>
<!-- {{(obsSearch.displayedTotal$ | async)}} -->
                <mat-paginator [length]="(obsSearch.displayedTotal$ | async)" [pageSize]="10" [hidePageSize]="true"
                      (page)="onObsPageChange($event)">
                </mat-paginator>
            } @else {
            <!-- Empty state -->
               @if (!(loading$ | async)) {
            <div class="g-just-flex flex-column align-items-center py-40" style="text-align:center;">
                <app-empty-state [icon]="'HOSPITAL'"></app-empty-state>
            </div>
        }
            }
        </div>

    </mat-card-content>
</mat-card>
<!-- (click)="showRow(row)" -->
